import { ChangeFlightComponent } from './../change-flight/change-flight.component';
import { AuthService } from './../../auth/auth.service';
import { UserService } from './../../users/user.service';
import { IUser } from './../../users/user';
import { IBranch } from './../../branches/branch';
import { ActivatedRoute, Params } from '@angular/router';
import { ITicket } from './../ticket';
import { CreateTicketComponent } from '../create/create-ticket.component';
import { Component, OnInit } from '@angular/core';
import { TicketService } from '../ticket.service';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LocationService } from '../../locations/location.service';
import { ILocation } from '../../locations/location';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TICKET_STATUSES, Helper } from '../../shared/helper';
import { BranchService } from '../../branches/branch.service';
import { IPickerDateChange } from '../../shared/datepicker-range/datepicker-range.component';

@Component({
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.css']
})
export class TicketsComponent implements OnInit {
  errorMessage: any;
  tickets: ITicket[];
  loaded = false;
  paging = {
    itemsPerPage: environment.itemsPerPage,
    total: 0,
    currentPage: 1
  };
  ticketForm: FormGroup;
  locations: ILocation[];
  branches: IBranch[];
  users: IUser[];
  TICKET_STATUSES = TICKET_STATUSES;
  exportUrl: string;
  selectedTickets = [];
  selectAllM: boolean;
  filterParams: Params;

  loggedInUser = null;
  isAdmin = false;

  constructor(
    private ticketService: TicketService,
    private fb: FormBuilder,
    private locationService: LocationService,
    private branchService: BranchService,
    private userService: UserService,
    private modalService: NgbModal,
    private helper: Helper,
    private activatedRoute: ActivatedRoute,
    private auth: AuthService
  ) {
    this.locationService.getLocations({}).subscribe(res => {
      this.locations = res.body;
    }, error => (this.errorMessage = <any>error));

    this.branchService.getBranches({}).subscribe(res => {
      this.branches = res.body;
    }, error => (this.errorMessage = <any>error));

    this.userService.getUsers({}).subscribe(res => {
      this.users = res.body;
    }, error => (this.errorMessage = <any>error));

    this.activatedRoute.queryParams.subscribe(params => {
      this.filterParams = params;
    });

    this.loggedInUser = this.auth.getUser();
    if (this.loggedInUser.roles.includes('ROLE_ADMIN')) {
      this.isAdmin = true;
    }

    console.log(this.loggedInUser);
    console.log(this.isAdmin);
  }

  ngOnInit(): void {
    this.ticketForm = this.fb.group({
      ticketNumber: [
        this.filterParams['ticket_number']
          ? this.filterParams['ticket_number']
          : ''
      ],
      ticketStatus: [
        this.filterParams['ticket_status']
          ? this.filterParams['ticket_status']
          : ''
      ],
      ticketBranch: [
        this.filterParams['ticket_branch']
          ? this.filterParams['ticket_branch']
          : ''
      ],
      ticketIssuer: [
        this.filterParams['ticket_issuer']
          ? this.filterParams['ticket_issuer']
          : ''
      ],
      ticketPrice: [
        this.filterParams['ticket_price']
          ? this.filterParams['ticket_price']
          : ''
      ],
      flightDateTime: [
        this.filterParams['flight_datetime']
          ? this.filterParams['flight_datetime']
          : ''
      ],
      ticketCreated: [
        this.filterParams['ticket_created']
          ? this.filterParams['ticket_created']
          : ''
      ],
      flightNumber: [
        this.filterParams['flight_number']
          ? this.filterParams['flight_number']
          : ''
      ],
      passengerGovId: [
        this.filterParams['passenger_govid']
          ? this.filterParams['passenger_govid']
          : ''
      ],
      passengerFirstName: [
        this.filterParams['passenger_firstname']
          ? this.filterParams['passenger_firstname']
          : ''
      ],
      passengerLastName: [
        this.filterParams['passenger_lastname']
          ? this.filterParams['passenger_lastname']
          : ''
      ],
      flightId: [
        this.filterParams['flight_id'] ? this.filterParams['flight_id'] : ''
      ]
    });
    this.filterTable();
  }

  orderList(e: any) {
    this.helper.clearEmptyFormFilds(this.ticketForm.value);
    const orderStr = this.helper.getOrderStr(e);
    if (orderStr) {
      this.getPage(this.paging.currentPage, this.ticketForm.value, orderStr);
    }
  }

  getPage(page: number, filterProps: any = {}, orderStr?: string) {
    this.loaded = false;
    let params = { itemsPerPage: this.paging.itemsPerPage, page: page };
    params = Object.assign(params, filterProps);
    this.ticketService.getTickets(params, orderStr).subscribe(res => {
      this.paging.total = Number(res.headers.get('X-total-count'));
      this.paging.currentPage = page;
      this.tickets = res.body;

      this.tickets.map(tk => {
        if (this.selectedTickets.find(stk => stk.id === tk.id)) {
          tk.selected = true;
        }
      });

      const exportUrl = res.url.replace('tickets', 'export/tickets').replace(
        /itemsPerPage=[0-9]+&page=[0-9]+/,
        'pagination=false'
      );
    
      this.exportUrl = exportUrl;

      this.loaded = true;
    }, error => (this.errorMessage = <any>error));
  }

  addTicket() {
    // this.editTicket(
    //   {
    //     id: 0,
    //     name: null,
    //     departure: { id: 0 },
    //     destination: { id: 0 }
    //   },
    //   -1,
    //   'add'
    // );
  }

  editTicket(ticket: ITicket, index: number) {
    const modalRef = this.modalService.open(CreateTicketComponent, {
      size: 'lg',
      backdrop: 'static'
      // beforeDismiss: () => confirm(`Are you sure to close form?`)
    });
    modalRef.result.then(
      res => {
        this.tickets[index] = res;
      },
      reason => {}
    );
    (<CreateTicketComponent>modalRef.componentInstance).editFormInit(ticket);
  }

  deleteTicket(ticket: ITicket, deletePermision?: boolean): void {
    if (!deletePermision) {
      if (confirm(`Are you sure to delete ticket ${ticket.ticketNumber}?`)) {
        deletePermision = true;
      }
    }
    if (deletePermision) {
      this.ticketService.deleteTicket(ticket.id).subscribe(val => {
        this.tickets.splice(this.tickets.indexOf(ticket), 1);
        console.log('Deleted ticket ', ticket.ticketNumber);
      }, error => (this.errorMessage = <any>error));
    }
  }

  selectTicket(ticket: ITicket, tagName = 'TD') {
    if (tagName === 'TD' || tagName === 'INPUT') {
      if (!ticket.selected) {
        this.selectedTickets.pushIfNotSimilar(ticket, 'id');
        ticket.selected = true;
      } else {
        this.selectedTickets.forEach((fl, i) => {
          if (fl.id === ticket.id) {
            this.selectedTickets.splice(i, 1);
            ticket.selected = false;
          }
        });
      }
    }
  }

  selectAll(e: any) {
    if (!this.selectAllM) {
      this.tickets.map(tk => {
        tk.selected = true;
        this.selectTicket(tk);
      });
    } else {
      this.tickets.map(tk => {
        tk.selected = false;
        this.selectTicket(tk);
      });
    }
  }

  bulkAction(e: any) {
    const action = e.target.value;
    const ids = this.selectedTickets.map(tk => tk.id).join(',');
    e.target.value = '';
    if (this.selectedTickets.length < 2 && action) {
      alert('Please select at least 2 tickets');
      return;
    }
    if (action === 'printEN') {
      window.open('/tickets/print/en/' + ids);
    } else if (action === 'printKA') {
      window.open('/tickets/print/ka/' + ids);
    } else if (action === 'delete') {
      if (
        confirm(
          `Are you sure you want to delete ${
            this.selectedTickets.length
          } tickets?`
        )
      ) {
        this.selectedTickets.forEach(tk => {
          this.deleteTicket(tk, true);
        });
      }
    }
    this.clearSelectedTickets();
  }

  clearSelectedTickets() {
    this.selectedTickets = [];
    this.tickets.map(fl => {
      fl.selected = false;
    });
    this.selectAllM = false;
  }

  filterTable(): void {
    const formValue = this.helper.clearEmptyFormFilds(this.ticketForm.value);
    this.getPage(1, formValue, '?order[ticketCreated]=DESC');
  }

  onFlightDateChange(e: IPickerDateChange) {
    const queryStr = `
      &ticketFlight.flightDateTime[after]=${e.after}
      &ticketFlight.flightDateTime[before]=${e.before}
    `;
    this.ticketForm.get('flightDateTime').setValue(queryStr);
  }

  onTicketDateChange(e: IPickerDateChange) {
    const queryStr = `
      &ticketCreated[after]=${e.after}
      &ticketCreated[before]=${e.before}
    `;
    this.ticketForm.get('ticketCreated').setValue(queryStr);
  }

  onClearDateFilter(key: string) {
    this.ticketForm.get(key).setValue('');
  }

  onChangeFlight(ticket: ITicket, index: number) {

      const modalRef = this.modalService.open(ChangeFlightComponent, {
        size: 'lg',
        backdrop: 'static'
        // beforeDismiss: () => confirm(`Are you sure to close form?`)
      });
      modalRef.result.then(
        res => {
          this.tickets[index] = res;
        },
        reason => { }
      );
      (<ChangeFlightComponent>modalRef.componentInstance).initTicket(ticket);
  }
}



// WEBPACK FOOTER //
// ./src/app/tickets/list/tickets.component.ts